// extracted by mini-css-extract-plugin
export default {"painel":"styles_painel__NmBKD","card":"styles_card__TKYgo"};